import Vue from 'vue'

const state = {
    search: '',
    tags: [],
    areas: [],
    areas: [],
    groups: [],
    all_tags: [],
    all_areas: [],
}

const actions = {
    SET_SEARCH(context, [search]) {
        context.commit('SAVE_SEARCH', [search])
    },

    SET_TAGS(context, [tags]) {
        context.commit('SAVE_TAGS', [tags])
    },

    SET_AREAS(context, [areas]) {
        context.commit('SAVE_AREAS', [areas])
    },

    SET_TAGS_AREAS(context, [areas, groups, all_tags, all_areas]) {
        context.commit('SAVE_TAGS_AREAS', [areas, groups, all_tags, all_areas])
    },

    SET_CLEAR_FILTERS(context, [search, areas]) {
        context.commit('SAVE_CLEAR_FILTERS', [search, areas])
    },
}

const mutations = {
    SAVE_SEARCH: (state, [search]) => {
        Vue.set(state, 'search', search)
    },

    SAVE_TAGS: (state, [tags]) => {
        Vue.set(state, 'tags', tags)
    },

    SAVE_AREAS: (state, [areas]) => {
        Vue.set(state, 'areas', areas)
    },

    SAVE_TAGS_AREAS: (state, [areas, groups, all_tags, all_areas]) => {
        Vue.set(state, 'areas', areas)
        Vue.set(state, 'groups', groups)
        Vue.set(state, 'all_tags', all_tags)
        Vue.set(state, 'all_areas', all_areas)
    },

    SAVE_CLEAR_FILTERS: (state, [search, areas]) => {
        Vue.set(state, 'search', search)
        Vue.set(state, 'areas', areas)
    },
}

const getters = {
    search: state => {
        return state.search
    },

    tags: state => {
        return state.tags
    },

    areas: state => {
        return state.areas
    },

    areas: state => {
        return state.areas
    },

    groups: state => {
        return state.groups
    },

    all_tags: state => {
        return state.all_tags
    },

    all_areas: state => {
        return state.all_areas
    },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
